<script setup lang="ts">
import { useAuthStore } from "~/store/auth/auth.store";
import { useSessionsStore } from "~/store/sessions/sessions-store";
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { useFormats } from "~/composables/utils/useFormat";
import { useSessionIndividual } from "~/composables/sessions/useSessionIndividual";
import { SessionStatusEnum } from "~/utils/enums/session-details-enums";

const sessionsStore = useSessionsStore();
const { trainingPlanSessionIndividual } = storeToRefs(sessionsStore);
const sessionIndividual = useSessionIndividual();
const authStore = useAuthStore();
const format = useFormats();
</script>

<template>
  <div class="session_user_info__container">
    <div class="flex gap-1 items-center">
      <h3 class="heading_3_demi text-primary-color p-[8px]">Détails de l'absence</h3>
      <SvgIcon
        v-if="authStore.isNotManager && sessionIndividual.getSessionHeading().status !== SessionStatusEnum.CANCELED"
        name="edit"
        class="w-[16px] h-[16px] text-secondary-color cursor-pointer"
        @click="() => (sessionsStore.showSessionStatusActionModal['no_show'] = true)"
      >
      </SvgIcon>
    </div>
    <div class="session_user_info__grid">
      <section>
        <h5>Motif d’absence</h5>
        <p class="truncate">{{ trainingPlanSessionIndividual?.noShowReason ?? "-" }}</p>
      </section>
      <section>
        <h5>Date d’annonce</h5>
        <p class="truncate">
          {{
            trainingPlanSessionIndividual?.noShowDate
              ? format.toDateDisplay(trainingPlanSessionIndividual?.noShowDate)
              : "-"
          }}
        </p>
      </section>
      <section>
        <h5>Commentaire</h5>
        <p>{{ trainingPlanSessionIndividual?.noShowDesc ?? "-" }}</p>
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.session_user_info__container {
  @apply pt-[8px];
  border-bottom: 1px solid var(--grey-lightest);
}

.session_user_info__grid {
  @apply flex flex-col gap-[8px] px-[8px] mb-[32px] mt-[16px];

  section {
    @apply inline-flex px-[8px];

    h5 {
      @apply min-w-[112px] mr-[8px];
      color: var(--text-secondary-color);
    }
  }
}
</style>
